import { jobList, jobPaymentDetails, regionList } from "constants/job";
const initialState = {
  jobList: {},
  jobPaymentDetails: {},
  regionList: {},
};

const job = (state = initialState, action) => {
  switch (action.type) {
    case jobList:
      return { ...state, jobList: action.payload };
    case jobPaymentDetails:
      return { ...state, jobPaymentDetails: action.payload };
    case regionList:
      return { ...state, regionList: action.payload };
    default:
      return state;
  }
};

export default job;